export default __webpack_public_path__ + "static/media/EmployeesIcon.949a7da3.svg";